(function ($, Promise) {

        // Constructor
        function PACCarteMontrealScreenSaver() {
            this.state = true;
            this.ticker = new PIXI.Ticker();
            this.counter = 0;

            // Init game canvas (PIXI)
            this.canvas = $("#screensaver-canvas").get(0);
            this.renderer = PIXI.Renderer.create({
                width: 1920,
                height: 1080,
                backgroundColor: 0x272625,
                view: this.canvas,
                resolution: 1,
                antialias: true,
                // resolution: window.devicePixelRatio || 1,
            });

            this.stage = new PIXI.Container();

            // Load textures
            var mapTexture = PIXI.Texture.from("images/carte_montreal/map_large.png");

            // Load sprite
            this.sprite = new PIXI.Sprite(mapTexture);
            this.sprite.anchor.set(0.5);
            this.sprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this.sprite.scale.set(1.45);
            this.stage.addChild(this.sprite);

            // Listen for animate update
            this.ticker.add($.proxy(this.draw, this));
        }

        PACCarteMontrealScreenSaver.prototype.start = function () {
            this.state = true;
            this.sprite.alpha = 1.0;
            this.ticker.start();
        }

        PACCarteMontrealScreenSaver.prototype.stop = function () {
            this.ticker.stop();
            this.state = false;
        }

        PACCarteMontrealScreenSaver.prototype.animateOut = function () {
            for (var i = 0; i < this.sprites.length; i++) {
                TweenMax.to(this.sprite, 0.6, {
                    alpha: 0,
                    ease: this.defaultEasing,
                    onComplete: this.stop,
                    onCompleteScope: this,
                });
            }
        }

        // Load settings JSON (with promise)
        PACCarteMontrealScreenSaver.prototype.draw = function (delta) {

            this.counter += delta;

            if (!this.stopped) {
                var x = Math.cos(this.counter * 0.005) * 100 + this.renderer.width / 2;
                var y = Math.sin(this.counter * 0.005) * 100 + this.renderer.height / 2;
                this.sprite.position.set(x, y);
            }

            // Trigger rendering
            this.renderer.render(this.stage);
        }

        PACCarteMontrealScreenSaver.prototype.reset = function () {

        }

        // Expose PACCarteMontrealScreenSaver
        window.PACCarteMontrealScreenSaver = PACCarteMontrealScreenSaver;
    }
)
(jQuery, Promise);
